module.exports = __webpack_public_path__ + "img/kia_k3.4b080461.jpg";